@use '../../../style/utils';

:host {
  display: block;
  margin-top: var(--joy-core-spacing-9);
}

::slotted([slot="panel-section-title"]) {
  @include utils.getFontProperties(primary-650);
  margin: 0;
}

::slotted([slot="panel-section-content"]) {
  margin: 0;
  @include utils.getFontProperties(primary-400);
}